import { SEASONAL } from "@/constants/seasonal";

const items = SEASONAL.ribbon;

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display italic text-xl md:text-2xl font-medium px-6 md:px-8 whitespace-nowrap">{t}</span>
        <span className="h-2 w-2 rounded-full bg-[#990000]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="border-y border-[#E5DEC9] bg-[#F3EDE4] py-4 overflow-hidden" data-testid="services-marquee">
    <div className="animate-marquee-x flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
